// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { LookUp } from './lookup';
import { Tooltip } from './tooltip';
import render from './render';
import createElement from './createElement';

import './object-switcher.less';

export class ObjectSwitcher extends LookUp {
    _initConfiguration(config) {
        super._initConfiguration({
            tag: 'div',
            cls: 'btn-group object-switcher',
            ...config,
        });

        this._listUrl = this._getConfigParam('listUrl', '');
        this._itemUrlTemplate = this._getConfigParam('itemUrlTemplate', '');
        this._owner = this._getConfigParam('owner', null);
        this._navigate = this._getConfigParam('navigate');
    }

    _initCustomLookUpComponent() {
        render(this._componentElement, createElement('button', {
            type: 'button',
            class: 'pul-button pul-button--ghost pul-button--empty dropdown-toggle',
            onrender: el => {
                this._customLookUpComponent = el;
            },
        }, '<span class="pul-icon pul-icon--size-16 pul-button__icon">' +
            '<svg focusable="false"><use href="/ui-library/images/symbols.svg?5f00d3c14f85d017780e960ab4a240ed#chevron-down:16" /></svg>' +
            '</span>'));
    }

    _getSearchMoreText(count) {
        return super._getSearchMoreText(count)
            + (this._listUrl ? ` ${this.lmsg('refineSearchMessage', { link: `<a href="${this._listUrl}">${this.lmsg('listOfAllObjects')}</a>` })}` : '');
    }

    _updateData(data) {
        this._clearData();

        let myData = [];

        if (null !== this._owner) {
            myData = data.filter(({ isSameParent }) => isSameParent == 1);

            data = data.filter(({ isSameParent }) => isSameParent != 1);
        }

        if (myData.length) {
            if (data.length) {
                render(this._dropdownList, createElement('li.dropdown-header', this.lmsg('myObjectsLabel', { name: this._owner })));
            }

            myData.forEach(item => {
                render(this._dropdownList, this._createItem(item));
            });

            if (data.length) {
                render(this._dropdownList, [
                    createElement('li.divider'),
                    createElement('li.dropdown-header', this.lmsg('otherObjectsLabel')),
                ]);
            }
        }

        data.forEach(item => {
            render(this._dropdownList, this._createItem(item));
        });

        this._addSearchMoreElement();
    }

    _addTooltips() {
        this._tooltip = Tooltip.init(this._customLookUpComponent, { text: this.lmsg('description') });
    }

    handleChange() {
        super.handleChange();

        let url = this._itemUrlTemplate;
        Object.entries(this._currentValue).forEach(([key, val]) => {
            url = url.replaceAll(new RegExp(`(%%|%25%25)${key}(%%|%25%25)`, 'g'), val);
        });

        this._navigate(url);
    }
}
